import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { OfficialInformationTable } from '../../components/officialInformationTable/officialInformationTable';
import { OfficialCommsTable } from '../../components/officialCommsTable/officialCommsTable';
import { PersonModel } from '../../models/personModel';
import { getPersonalDetailsByIdReq } from '../../api/person/personalDetailsApi';
import { OfficialProfileNavbar } from '../../components/officialProfileNavbar/officialProfileNavbar';
import { OfficialAvatarAndName } from '../../components/officialAvatarAndName/officialAvatarAndName';

export function OfficialDetails() {
  const { personId } = useParams();
  const [official, setOfficial] = useState<PersonModel>();

  useEffect(() => {
    async function getOfficialProfile() {
      if (!personId?.trim()) return;
      const response = await getPersonalDetailsByIdReq(personId.trim());
      if (response) {
        setOfficial(response.data);
      }
    }
    getOfficialProfile();
  }, [setOfficial, personId]);

  return (
    <Grid container direction='column'>
      <OfficialProfileNavbar selectedIndex={1} personId={personId} />
      <OfficialAvatarAndName official={official} />
      <Grid item container direction='row'>
        <Grid item xs={12} sm={6}>
          <OfficialInformationTable official={official} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <OfficialCommsTable official={official} />
        </Grid>
      </Grid>
    </Grid>
  );
}
